export default __webpack_public_path__ + "static/infastructure-min-697bc7cef94f41eccac01e020c6cbef1.png";